import ContactsVue from '@/views/sm/contacts/contacts.vue';

const basePath = '/sm/contacts';
const role = 'sm'; // 角色身份

export const SM_CONTACTS_INDEX = 'sm-contacts-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ContactsVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SM_CONTACTS_INDEX,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/contacts/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
